/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Constant definitions
 */

export const BERLIN_TENANT_ID_HEADER = 'x-berlin-tenant-id';
export const BERLIN_API_V1_VERSION = 'api/1.0';
export const BERLIN_API_TIMEOUT = 60000;
export const EVG_V1_VERSION = 'api/v1';

export const GET_TENANT_LIST = 'GET_TENANT_LIST';
export const GET_TENANT_LIST_SUCCESS = 'GET_TENANT_LIST_SUCCESS';

export const GET_TENANT_PROVIDER_LIST = 'GET_TENANT_PROVIDER_LIST';
export const GET_TENANT_PROVIDER_SUCCESS = 'GET_TENANT_PROVIDER_SUCCESS';
export const GET_TENANT_LIST_STATUS = 'GET_TENANT_LIST_STATUS';
export const FILTER_TYPE = 'FILTER_TYPE';
